import React, { useEffect, useState } from 'react';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Swal from 'sweetalert2'
import _ from 'lodash';
import { listaEventos, buscaEmailsMarketing, listaTransmissoes, enviaEmailMarketing } from '../../services/mysql'
import moment from 'moment/moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default function EmailMarketing() {
    const [academias, setAcademias] = useState([])
    const [eventos, setEventos] = useState([])
    const [transmissoes, setTransmissoes] = useState([])
    const [evento, setEvento] = useState('')
    const [mesAno, setMesAno] = useState(moment().format('YYYY-MM'))
    const [tipoEvento, setTipoEvento] = useState('eventos')
    const [filtro] = useState({
        anoMes: moment().format('YYYY-MM'),
        idEvento: null,
        tipoEvento: 'eventos',
        idProdutor: '',
        perfil: ''
    })
    const [listaExcel, setListaExcel] = useState([])
    const [tituloEmail, setTituloEmail] = useState('')
    const [textoEmail, setTextoEmail] = useState('')
    const [imagemEmail, setImagemEmail] = useState(null)
    const [formEmailKey, setFormEmailKey] = useState(0)
    const [destinatariosSelecionados, setDestinatariosSelecionados] = useState([])
    const [enviandoEmail, setEnviandoEmail] = useState(false)

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('userd7'))
        mensagemLoading('Carregando Dados...')
        const data = {
            id: user.id,
            perfil: user.perfil
        }
        listaEventos(data).then((res) => {
            if (res.erro) {
                mensagemErro(res.message)
            } else {
                setEventos(res)
            }
            Swal.close()
        })
        listaTransmissoes(data).then((res) => {
            if (res.erro) {
                mensagemErro(res.message)
            } else {
                setTransmissoes(res)
            }
            Swal.close()
        })
    }, {})

    function filtrar() {
        const user = JSON.parse(localStorage.getItem('userd7'))
        setAcademias([])
        // filtro.anoMes = mesAno
        filtro.idEvento = evento ? evento : null
        filtro.tipoEvento = tipoEvento
        filtro.idProdutor = user.id
        filtro.perfil = user.perfil
        mensagemLoading('Buscando Emails...')

        buscaEmailsMarketing(filtro).then((res) => {
            if (res.erro) {
                Swal.close()
                mensagemAlerta(res.message)
            } else {
                Swal.close()
                const list = []
                res.pagamentos.forEach(element => {
                    list.push({
                        nomeUsuario: element.nomeUsuario,
                        email: element.email,
                        salaVip: element.salaVip
                    })
                });
                const vipFalse = list.filter(item => !item.salaVip);
                const vipTrue = list.filter(item => item.salaVip);

                const tabelaFalse = vipFalse.map((item, index) => ({
                    numero: index + 1,
                    salaVip: false,
                    nomeUsuario: item.nomeUsuario,
                    email: item.email
                }));

                const tabelaTrue = vipTrue.map((item, index) => ({
                    numero: index + 1,
                    salaVip: true,
                    nomeUsuario: item.nomeUsuario,
                    email: item.email
                }));
                const tabelaFinal = [...tabelaFalse, ...tabelaTrue];
                setListaExcel(tabelaFinal)
                setAcademias(tabelaFinal)
                setTituloEmail('')
                setTextoEmail('')
                setImagemEmail(null)
                setFormEmailKey((key) => key + 1)
                setDestinatariosSelecionados([])
            }
        })

    }

    function exportToExcel() {

        var nomeEvento = tipoEvento == 'eventos'
            ? eventos.filter((d) => d.id === parseInt(evento))[0].nome
            : transmissoes.filter((d) => d.id === parseInt(evento))[0].nome;
    
        // Separar os dados
        const pagantes = listaExcel.filter(item => !item.salaVip);
        const vips = listaExcel.filter(item => item.salaVip);
        vips["!cols"] = [
            { wch: 10 }, // Número
            { wch: 10 }, // Nome
            { wch: 40 }, // Email
            { wch: 40 }, // Email
        ];
    
        // Formatar dados Pagantes
        const dadosPagantes = pagantes.map((item, index) => ({
            "Ordem": index + 1,
            "SalaVip": "Nao",
            "Nome": item.nomeUsuario,
            "Email": item.email
        }));
    
        // Formatar dados VIP
        const dadosVip = vips.map((item, index) => ({
            "Codigo": index + 1,
            "SalaVip": "Sim",
            "Nome": item.nomeUsuario,
            "Email": item.email
        }));
    
        // Criar planilhas
        const worksheetPagantes = XLSX.utils.json_to_sheet(dadosPagantes);
        worksheetPagantes["!cols"] = [
            { wch: 10 }, // Número
            { wch: 10 }, // Nome
            { wch: 40 }, // Email
            { wch: 40 }, // Email
        ];
        const worksheetVip = XLSX.utils.json_to_sheet(dadosVip);
        worksheetVip["!cols"] = [
            { wch: 10 }, // Número
            { wch: 10 }, // Nome
            { wch: 40 }, // Email
            { wch: 40 }, // Email
        ];
    
        // Criar workbook
        const workbook = XLSX.utils.book_new();
    
        XLSX.utils.book_append_sheet(workbook, worksheetPagantes, 'Pagantes');
        XLSX.utils.book_append_sheet(workbook, worksheetVip, 'Vip');
    
        // Gerar arquivo
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    
        saveAs(blob, `Emails Exportados - ${nomeEvento}.xlsx`);
    }

    async function enviarPorEmail() {
        if (!tituloEmail.trim() || !textoEmail.trim() || !imagemEmail) {
            mensagemAlerta('Preencha o título, o texto e selecione uma imagem para continuar.')
            return
        }

        if (!imagemEmail.type.startsWith('image/')) {
            mensagemAlerta('Selecione um arquivo de imagem válido.')
            return
        }

        if (destinatariosSelecionados.length === 0) {
            mensagemAlerta('Selecione pelo menos um destinatário para enviar o email.')
            return
        }

        const destinatarios = academias
            .filter((destinatario) => destinatariosSelecionados.includes(getChaveDestinatario(destinatario)))
            .map((destinatario) => ({
                nome: destinatario.nomeUsuario,
                email: destinatario.email
            }))

        // Destinatários temporários para teste do envio.
        // const destinatarios = [
        //     { nome: 'Guilherme', email: 'guilherme.si2012@gmail.com' },
        //     { nome: 'Guilherme', email: 'guilherme@ielop.com' },
        //     { nome: 'Alexandre', email: 'guilherme@ielop.com' }
        // ]

        try {
            setEnviandoEmail(true)
            mensagemLoading('Enviando emails...')

            const dadosEmail = new FormData()
            dadosEmail.append('titulo', tituloEmail.trim())
            dadosEmail.append('texto', textoEmail.trim())
            dadosEmail.append('imagem', imagemEmail)
            dadosEmail.append('destinatarios', JSON.stringify(destinatarios))

            const resposta = await enviaEmailMarketing(dadosEmail)

            Swal.close()

            if (resposta.erro) {
                mensagemErro(resposta.message || 'Não foi possível enviar os emails.')
                return
            }

            await Swal.fire(
                'Sucesso',
                resposta.message || `Email enviado para ${destinatarios.length} destinatário(s).`,
                'success'
            )

            // setTituloEmail('')
            // setTextoEmail('')
            // setImagemEmail(null)
            setDestinatariosSelecionados([])
            setFormEmailKey((key) => key + 1)
        } catch (error) {
            Swal.close()
            mensagemErro(error.message || 'Não foi possível enviar os emails.')
        } finally {
            setEnviandoEmail(false)
        }
    }

    function getChaveDestinatario(destinatario) {
        return `${destinatario.salaVip ? 'vip' : 'pagante'}-${destinatario.numero}-${destinatario.email}`
    }

    function selecionarDestinatario(destinatario) {
        const chave = getChaveDestinatario(destinatario)

        setDestinatariosSelecionados((selecionados) =>
            selecionados.includes(chave)
                ? selecionados.filter((item) => item !== chave)
                : [...selecionados, chave]
        )
    }

    function selecionarTodos() {
        if (destinatariosSelecionados.length === academias.length) {
            setDestinatariosSelecionados([])
            return
        }

        setDestinatariosSelecionados(academias.map(getChaveDestinatario))
    }

    const handleMesAno = (event) => {
        event.persist();
        setMesAno(event.target.value);
    }
    const handleTipoPagamento = (event) => {
        setAcademias([])
        event.persist();
        if (event.target.value === 'transmissao') {
            setTipoEvento('transmissao')
        } else {
            setTipoEvento('eventos')
        }
    }
    const handleEvento = (event) => {
        event.persist();
        if (event.target.value === 'all') {
            setEvento(null)
        } else {
            setEvento(event.target.value);
        }
    }

    // Mensagens
    function mensagemAlerta(msg) {
        Swal.fire('Alerta', msg, 'warning')
    }

    function mensagemErro(msg) {
        Swal.fire('Erro', msg, 'error')
    }
    function mensagemSucesso(msg) {
        Swal.fire('Sucesso', msg, 'success').then(() => {
            mensagemLoading('Atualizando Eventos...')
            listaEventos().then((res) => {
                Swal.close()
                setAcademias(res)
            })
        })
    }

    function mensagemLoading(msg) {
        Swal.fire({
            title: 'Aguarde',
            html: msg,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })
    }
    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Menu />
                <div class="layout-page">
                    <div>
                        <Header />
                        <div className="content-wrapper">
                            <div className="container-xxl flex-grow-1 " style={{ marginTop: 20 }}>
                                <div className="card">
                                    <div className='row'>
                                        <div className='col-md-10'>
                                            <h5 className="card-header">Emails Marketing</h5>
                                        </div>
                                    </div>
                                    <div className='card-body row'>
                                        <div class="col-md-2">
                                            <label class="form-label" for="basic-icon-default-fullname">Tipo de Pagamento</label>
                                            <select id="defaultSelect" className="form-select" onChange={handleTipoPagamento}  >
                                                <option>Selecione</option>
                                                <option value={'eventos'} selected={tipoEvento === 'eventos' ? 'selected' : null}>Eventos</option>
                                                <option value={'transmissao'} selected={tipoEvento === 'transmissao' ? 'selected' : null}>Transmissões</option>
                                            </select>
                                        </div>
                                        {tipoEvento == 'eventos' ?
                                            <div class="col-md-4">
                                                <label class="form-label" for="basic-icon-default-fullname">Por Evento</label>
                                                <select id="defaultSelect" className="form-select" onChange={handleEvento}  >
                                                    <option>Selecione</option>
                                                    <option value={'all'}>Todos</option>
                                                    {eventos.map((evento, index) =>
                                                        <option value={evento.id} >{evento.nome}</option>
                                                    )}
                                                </select>
                                            </div>
                                            :
                                            <div class="col-md-4">
                                                <label class="form-label" for="basic-icon-default-fullname">Por Transmissão</label>
                                                <select id="defaultSelect" className="form-select" onChange={handleEvento}  >
                                                    <option>Selecione</option>
                                                    <option value={'all'}>Todos</option>
                                                    {transmissoes.map((evento) =>
                                                        <option value={evento.id} >{evento.nome}</option>
                                                    )}
                                                </select>
                                            </div>
                                        }

                                        <div class="col-md-3" style={{ marginTop: 30 }}>
                                            <button onClick={() => filtrar()} type="submit" className="btn btn-primary me-2">Filtrar</button>
                                        </div>
                                        {academias.length > 0 ?
                                            <div className="col-12 mt-4" key={formEmailKey}>
                                                <div className="row g-3">
                                                    <div className="col-md-6">
                                                        <label className="form-label" htmlFor="tituloEmail">Título</label>
                                                        <input
                                                            id="tituloEmail"
                                                            type="text"
                                                            className="form-control"
                                                            value={tituloEmail}
                                                            onChange={(event) => setTituloEmail(event.target.value)}
                                                            placeholder="Digite o título do email"
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label" htmlFor="imagemEmail">Imagem</label>
                                                        <input
                                                            id="imagemEmail"
                                                            type="file"
                                                            className="form-control"
                                                            accept="image/*"
                                                            onChange={(event) => setImagemEmail(event.target.files[0] || null)}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        <label className="form-label" htmlFor="textoEmail">Texto</label>
                                                        <textarea
                                                            id="textoEmail"
                                                            className="form-control"
                                                            rows="5"
                                                            value={textoEmail}
                                                            onChange={(event) => setTextoEmail(event.target.value)}
                                                            placeholder="Digite o conteúdo do email"
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        <button onClick={() => exportToExcel(academias)} type="button" className="btn btn-success me-2">Exportar em Excel</button>
                                                        <button onClick={enviarPorEmail} type="button" className="btn btn-primary" disabled={enviandoEmail}>
                                                            {enviandoEmail ? 'Enviando...' : 'Enviar por email'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                    <div className="table-responsive text-nowrap">
                                        {tipoEvento === 'eventos' ?
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={academias.length > 0 && destinatariosSelecionados.length === academias.length}
                                                                onChange={selecionarTodos}
                                                                aria-label="Selecionar todos os destinatários"
                                                            />
                                                        </th>
                                                        <th>Codigo</th>
                                                        <th>Vip</th>
                                                        <th>Nome</th>
                                                        <th>Email</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="table-border-bottom-0">
                                                    {academias.sort((a, b) => moment(b.dataPagamento).diff(moment(a.dataPagamento))).map((pagamento, index) =>
                                                        <tr key={index}>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    checked={destinatariosSelecionados.includes(getChaveDestinatario(pagamento))}
                                                                    onChange={() => selecionarDestinatario(pagamento)}
                                                                    aria-label={`Selecionar ${pagamento.nomeUsuario}`}
                                                                />
                                                            </td>
                                                            <td>{pagamento.numero}</td>
                                                            <td>
                                                                {pagamento.salaVip ?
                                                                    <span class="badge bg-label-success me-1">
                                                                        <i className="menu-icon tf-icons bx bx-check" />
                                                                    </span>
                                                                    :
                                                                    <span class="badge bg-label-danger me-1">
                                                                        <i className="menu-icon tf-icons bx bx-x" />
                                                                    </span>
                                                                }
                                                            </td>
                                                            <td>{pagamento.nomeUsuario}</td>
                                                            <td>{pagamento.email}</td>
                                                        </tr>
                                                    )}
                                                    {academias.length === 0 ?
                                                        <p style={{ textAlign: 'center', padding: 10 }} >Sem emails para o evento</p>
                                                        :
                                                        null
                                                    }

                                                </tbody>
                                            </table>
                                            :
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={academias.length > 0 && destinatariosSelecionados.length === academias.length}
                                                                onChange={selecionarTodos}
                                                                aria-label="Selecionar todos os destinatários"
                                                            />
                                                        </th>
                                                        <th>Código</th>
                                                        <th>Vip</th>
                                                        <th>Nome</th>
                                                        <th>Email</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="table-border-bottom-0">
                                                    {academias.sort((a, b) => moment(b.dataPagamento).diff(moment(a.dataPagamento))).map((pagamento, index) =>
                                                        <tr key={index}>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    checked={destinatariosSelecionados.includes(getChaveDestinatario(pagamento))}
                                                                    onChange={() => selecionarDestinatario(pagamento)}
                                                                    aria-label={`Selecionar ${pagamento.nomeUsuario}`}
                                                                />
                                                            </td>
                                                            <td>{pagamento.numero}</td>
                                                            <td>
                                                                {pagamento.salaVip ?
                                                                    <span class="badge bg-label-success me-1">
                                                                        <i className="menu-icon tf-icons bx bx-check" />
                                                                    </span>
                                                                    :
                                                                    <span class="badge bg-label-danger me-1">
                                                                        <i className="menu-icon tf-icons bx bx-x" />
                                                                    </span>
                                                                }
                                                            </td>
                                                            <td>{pagamento.nomeUsuario}</td>
                                                            <td>{pagamento.email}</td>
                                                        </tr>
                                                    )}
                                                    {academias.length === 0 ?
                                                        <p style={{ textAlign: 'center', padding: 10 }} >Sem Emails para transmissão</p>
                                                        :
                                                        null
                                                    }

                                                </tbody>
                                            </table>
                                        }

                                    </div>
                                </div>

                            </div>

                            <Footer />
                            <div className="content-backdrop fade" />
                        </div>
                        {/* Content wrapper */}
                    </div>
                </div>

            </div>
        </div>

    );
}
